import { isHighOrLowTouchTwcSignup } from '@atlassian/twc-signup-touch/is-high-or-low-touch-twc-signup';

import { useSiteTraits } from '@confluence/targeting/entry-points/useSiteTraits.ts';

export type UseIsHighOrLowTouchTwcSignupResult = {
	isHighTouch: boolean | null;
	isLowTouch: boolean | null;
	loading: boolean;
	error: Error | null;
};

export function useIsHighOrLowTouchTwcSignup(): UseIsHighOrLowTouchTwcSignupResult {
	// Meeting-signal routing consumes the TAP context already bootstrapped by Confluence. It must
	// not introduce an ungated trait request of its own on every attach point.
	const { data, loading, error } = useSiteTraits({ skipBootstrap: true });
	const signupTouch = isHighOrLowTouchTwcSignup(data?.attributes ?? undefined);

	return {
		isHighTouch: signupTouch === null ? null : signupTouch === 'highTouch',
		isLowTouch: signupTouch === null ? null : signupTouch === 'lowTouch',
		loading,
		error,
	};
}
